import React, { useEffect, useState } from "react";
import "./Styles/Home.css";
import "../pages/Styles/Home.css";
import ButtonComponent from "../components/ButtonComponent";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { apiUrl } from "../config/api";

import videoBackground from "../assets/triple.mp4"; // fallback if no admin video is set yet

const Home = () => {
  const navigate = useNavigate();
  const [videoSrc, setVideoSrc] = useState(videoBackground);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(apiUrl("/api/settings"))
      .then(({ data }) => {
        if (!cancelled && data?.data?.homeVideoUrl) {
          setVideoSrc(data.data.homeVideoUrl);
        }
      })
      .catch(() => {
        // Keep the bundled fallback video on any error.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const discoverMore = () => {
    navigate("/products");
  };

  return (
    <div className="Home-main-component d-flex">
      <video autoPlay loop muted playsInline key={videoSrc} className="video-background video-responsive " >
        <source src={videoSrc} type="video/mp4" />
      </video>
        <div className='discover-more-cta-button'><ButtonComponent  onClick={discoverMore}>Discover more</ButtonComponent></div>
    </div>
  );
};

export default Home;
